export default function Footer() {
  return (
    <footer className="bg-void border-t border-white/6 py-8 text-center">
      <p className="text-milk-dim text-xs font-mono tracking-wider">
        © 2024 <span className="text-copper-light">Reem Ziadeh</span> · Electrical Power Engineer
      </p>
    </footer>
  );
}
